import { BrowserRouter, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { AppRoutes } from './router';
import Navbar from './components/feature/Navbar';
import Footer from './components/feature/Footer';
import ScrollToTop from './components/feature/ScrollToTop';
import { Toaster } from 'sonner';
import { getEtablissementColors, getEtablissementFromPath } from './utils/etablissement';
import { LOGOS } from './config/logos';

function AppContent() {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const theme = getEtablissementColors(location.pathname);

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty('--theme-primary', theme.primary);
    root.style.setProperty('--theme-secondary', theme.secondary);
    root.style.setProperty('--theme-accent', theme.accent);
    root.style.setProperty('--theme-background', theme.background);
    root.style.setProperty('--theme-text', theme.text);
    root.style.setProperty('--theme-primary-soft', `${theme.primary}22`);

    const etablissement = getEtablissementFromPath(location.pathname);
    const logoByEtablissement = {
      'lycee-francais': LOGOS.lyceeFrancais,
      'lycee-ivoirien': LOGOS.lyceeIvoirien,
      institut: LOGOS.institut,
      'maternelle-primaire': LOGOS.maternellePrimaire,
      portail: LOGOS.portail,
    } as const;

    const favicon = document.querySelector("link[rel='icon']") || document.createElement('link');
    favicon.setAttribute('rel', 'icon');
    favicon.setAttribute('type', 'image/png');
    favicon.setAttribute('href', logoByEtablissement[etablissement]);
    if (!favicon.parentNode) {
      document.head.appendChild(favicon);
    }
  }, [location.pathname, theme]);

  // Pages d'établissements qui ne doivent pas afficher le Navbar et Footer du portail
  const etablissementPages = [
    '/lycee-francais',
    '/lycee-ivoirien',
    '/institut',
    '/maternelle-primaire'
  ];

  const isEtablissementPage = etablissementPages.some(path => location.pathname.startsWith(path));

  return (
    <>
      {!isEtablissementPage && <Navbar />}
      <AppRoutes />
      {!isEtablissementPage && <Footer />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <Toaster />
      <ScrollToTop />
      <div className="overflow-x-hidden">
        <AppContent />
      </div>
    </BrowserRouter>
  );
}

export default App;
